"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var TooltipHost_base_1 = require("./TooltipHost.base");
var TooltipHost_styles_1 = require("./TooltipHost.styles");
exports.TooltipHost = Utilities_1.styled(TooltipHost_base_1.TooltipHostBase, TooltipHost_styles_1.getStyles, undefined, {
    scope: 'TooltipHost'
});
//# sourceMappingURL=TooltipHost.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Tooltip/TooltipHost.js
// module id = 634
// module chunks = 0